import { all, put, select, takeLatest } from 'redux-saga/effects';
import { EmprestimoService } from '@services/emprestimo';

import {
  OBTER_CONTRATOS_REQUEST,
  OBTER_DADOS_SOLICITACAO_REQUEST,
  OBTER_LIMITE_EMPRESTIMO_REQUEST,
} from './constants';
import {
  obterContratosSuccess,
  obterDadosSolicitacaoSuccess,
  obterLimiteEmprestimoSuccess,
} from './actions';
import { hideLoad, showLoad } from '../loading/actions';

function* obterContratosRequest() {
  const service = new EmprestimoService();
  const user = yield select((state) => state.user);

  yield put(showLoad());

  const response = yield service.obterContratos({
    matricula: user.matricula,
    token: user.token,
  });

  yield put(obterContratosSuccess(response.data));

  yield put(hideLoad());
}

function* obterLimiteEmprestimo() {
  const service = new EmprestimoService();
  const { matricula, token } = yield select((state) => state.user);

  const response = yield service.obterLimiteEmprestimo({ matricula, token });

  yield put(
    obterLimiteEmprestimoSuccess({
      total: parseFloat(response.E_LIM_MAX, 10),
      limiteMinimo: parseFloat(response.E_LIM_MIN, 10),
      novoContratoBloqueado:
        response.E_INADIM === 'S' || response.E_CARENCIA === 'S',
      saldoDevedor: parseFloat(response.T_SLDDEV, 10),
      quantidadeMaximaParcelas: parseInt(response.E_PRAZO_MAX_REAL, 10),
      taxa: parseFloat(response.E_TXJRS_AA, 10),
      taxaMes: parseFloat(response.E_TXJRS_AM, 10),
      taxaFundo: parseFloat(response.E_TXSEG_AM, 10),
      msgErro: response.ERRO_SHAREPOINT,
      msgBloqueio: response.T_BLOQUEIO,
    })
  );
}

function* obterDadosSolicitacao() {
  const service = new EmprestimoService();
  const user = yield select((state) => state.user);
  const { valor, parcelas } = yield select(
    (state) => state.emprestimo.simulacao
  );

  if (valor && Number(parcelas)) {
    yield put(showLoad());

    const emprestimo = yield service.obterValoresEmprestimoInicial({
      matricula: user.matricula,
      token: user.token,
      valor,
      parcelas,
    });

    yield put(
      obterDadosSolicitacaoSuccess({
        matrizOpcoesParcelas: emprestimo.T_SIMPARC[0].item.reverse(),
        dataPrimeiraParcela: emprestimo.E_DT_PRIM_PREST[0],
        parcelaMinCalculada: Number(emprestimo.T_SIMPARC[0].item[0].PRAZO[0]),
        valorLiberado: Number(emprestimo.E_VLRLIQ[0]),
        valorParcelas: Number(emprestimo.T_SIMPARC[0].item[0].VLR_PARC[0]),
        dataPrevistaCredito: emprestimo.E_DT_DESEMB[0],
      })
    );

    yield put(hideLoad());
  }
}

export default all([
  takeLatest(OBTER_CONTRATOS_REQUEST, obterContratosRequest),
  takeLatest(OBTER_DADOS_SOLICITACAO_REQUEST, obterDadosSolicitacao),
  takeLatest(OBTER_LIMITE_EMPRESTIMO_REQUEST, obterLimiteEmprestimo),
]);
